import { render, staticRenderFns } from "./CustomerComplaintAreaOwner.vue?vue&type=template&id=3ea96e8c&"
import script from "./CustomerComplaintAreaOwner.vue?vue&type=script&lang=js&"
export * from "./CustomerComplaintAreaOwner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports